<p-popover #panel [dismissable]="true" styleClass="!p-0 !bg-transparent !border-none">
  <div class="min-w-[178px] rounded-xl border border-lGray700/80 bg-lGray950 p-2 shadow-popover">
    @for (action of actions; track action.label) {
      @if (action.routerLink) {
        <a
          [routerLink]="action.routerLink"
          [queryParams]="action.queryParams"
          class="flex items-center gap-2 rounded-lg px-3 py-2 text-base no-underline transition-colors hover:bg-lGray800/70"
          [class.opacity-50]="action.disabled"
          [class.pointer-events-none]="action.disabled"
          [ngClass]="action.colorClass || 'text-lWhite'"
          (click)="$event.stopPropagation(); hide()"
        >
          <l-icon class="text-base">{{ action.icon }}</l-icon>
          <span class="flex-1">{{ action.label }}</span>
        </a>
      } @else {
        <button
          type="button"
          class="flex w-full items-center gap-2 rounded-lg px-3 py-2 text-base transition-colors hover:bg-lGray800/70"
          [class.opacity-50]="action.disabled"
          [class.pointer-events-none]="action.disabled"
          [ngClass]="action.colorClass || 'text-lWhite'"
          (click)="handleAction(action, $event)"
        >
          <l-icon class="text-base">{{ action.icon }}</l-icon>
          <span class="flex-1 text-left">{{ action.label }}</span>
        </button>
      }
    }
  </div>
</p-popover>

